import {
  createFirstNameSchema,
  createLastNameSchema,
  createSalutationSchema,
  createEmailSchema,
  createTerminationTypeSchema,
  createBirthDateSchema,
  createAccountNumberWithKrakenSchema,
  createZipWithAutoCompleteSchema,
  createHouseNumberSchema,
  createAdditionSchema,
  createStreetSchema,
  terminationDateSchema,
  createCountrySchema,
  createPhoneSchema,
  createReachabilitySchema,
  createMoveOutDateSchema,
} from './field-schemas';
import {
  AddressType,
  DependencyConditionType,
  ExtraordinaryTerminationReason,
  FormActionType,
} from 'ewi-ui-helpers/types';
export const CANCELLATION_SCHEMA = {
  name: 'cancellation',
  submitAction: {
    type: FormActionType.SubmitAndRedirect,
    actionUrl: '/_contract/cancel',
    redirectUrl: 'https://www.google.com',
    mapperFnName: 'mapFormDataToSend',
  },
  steps: [
    {
      stepStage: 0,
      title: 'Kündigung',
      summaryTitle: 'Kündigung',
      submitText: 'Vertrag jetzt kündigen!',
      fields: [
        createTerminationTypeSchema(),
        createSalutationSchema(),
        createFirstNameSchema(),
        createLastNameSchema(),
        createBirthDateSchema(),
        createEmailSchema('email', undefined, false),
        createAccountNumberWithKrakenSchema(),
        terminationDateSchema(),
        {
          ...createZipWithAutoCompleteSchema(
            `${AddressType.Cancellation}PostcodeAndCity`,
          ),

          info: {
            text: '<h3>Deine aktuelle Adresse</h3>',
            position: 'top',
            textColor: 'dark',
          },
        },
        createStreetSchema(AddressType.Cancellation),
        createHouseNumberSchema(),
        createAdditionSchema(),
        createMoveOutDateSchema(),
        {
          ...createCountrySchema(),
          info: {
            text: 'Deine neue Adresse',
            position: 'top',
            textColor: 'dark',
          },
        },
        {
          ...createPhoneSchema('phone', true, 'Mobilfunknummer'),
          info: {
            text: '<h3>Rückruf</h3><p>(Ausschließlich für Fragen zu deinem Umzug)</p>',
            position: 'top',
            textColor: 'dark',
          },
          dependsOnCondition: {
            type: DependencyConditionType.storeValueEquals,
            details: {
              fieldName: 'extraordinaryTerminationReason',
              value: ExtraordinaryTerminationReason.Relocation,
            },
          },
        },
        createReachabilitySchema(),
      ],
    },
  ],
};
